"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.useStyles = void 0;
var _theme = require("../../../../theme");
var useStyles = (0, _theme.makeStyles)(function (_ref) {
  var typography = _ref.typography,
    primary = _ref.palette.primary;
  return {
    root: {
      textDecoration: 'none',
      textTransform: 'uppercase',
      color: '#343434',
      borderBottom: '3px solid transparent',
      fontSize: '12px',
      lineHeight: '17px',
      marginLeft: '40px',
      padding: 0,
      fontWeight: typography.fontWeightSemiBold,
      minWidth: 0,
      letterSpacing: '1.8px',
      minHeight: '61px',
      '&:first-child': {
        marginLeft: 0
      },
      '&:hover, &:focus': {
        color: primary.main
      }
    },
    selected: {
      color: primary.main
    }
  };
}, {
  name: 'Tab'
});
exports.useStyles = useStyles;